import "reflect-metadata";
import {inject, injectable} from "inversify";
import {PlanExtensionsCatalogRepository} from "@dropDesk/domain/repositories/plan_extensions/plan_extensions_catalog.repository";
import {PlanExtensionSimulateHireEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_simulate_hire.entity";

@injectable()
export class SimulateHirePlanExtensionUseCase {
    private _repository: PlanExtensionsCatalogRepository;

    constructor(@inject(PlanExtensionsCatalogRepository) repository: PlanExtensionsCatalogRepository) {
        this._repository = repository;
    }

    public call(idExtension: string): Promise<PlanExtensionSimulateHireEntity> {
        return this._repository.simulateHire(idExtension);
    }
}
